<template>
  <b-row>
    <b-col>
      <b-form-input
        v-model="simpleLimit"
        placeholder="Limit"
        type="number"
        min="0"
        :id="id + '-limit'"
        data-trigger="hover"
        :disabled="currentUser.id !== 1"
      ></b-form-input>
      <b-tooltip :target="id + '-limit'" triggers="hover"
        >Clicks count/percent</b-tooltip
      >
    </b-col>
    <b-col>
      <b-form-select
        v-model="simpleValueType"
        :options="valueType"
        :disabled="currentUser.id !== 1"
      ></b-form-select>
    </b-col>
    <b-col>
      <b-form-select
        v-model="simpleType"
        :options="typesArray"
        :disabled="currentUser.id !== 1"
      ></b-form-select>
    </b-col>
    <b-col>
      <b-form-input
        v-model="simpleThresh"
        placeholder="Thresh value"
        type="number"
        min="0"
        :id="id + '-thresh'"
        data-trigger="hover"
        :disabled="currentUser.id !== 1"
      ></b-form-input>
      <b-tooltip :target="id + '-thresh'" triggers="hover">Seconds</b-tooltip>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    params: {
      type: Object,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      times: {
        minutes: 60,
        hours: 3600,
        days: 84600,
        weeks: 604800,
        months: 2419200
      },
      valueType: [
        {
          text: "Value",
          value: "value"
        },
        {
          text: "Percent",
          value: "percent"
        }
      ],
      typesArray: [
        {
          text: "Less (<)",
          value: ">" // у нас правила наоборот работают
        },
        {
          text: "Greater (>)",
          value: "<" // у нас правила наоборот работают
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["currentUser"]),
    simpleLimit: {
      get() {
        return this.params.limit;
      },
      set(newValue) {
        this.params.limit = Math.abs(parseInt(newValue));
        this.$emit("change");
      }
    },
    simpleThresh: {
      get() {
        return this.params.thresh;
      },
      set(newValue) {
        this.params.thresh = Math.abs(parseInt(newValue));
        this.$emit("change");
      }
    },
    simpleType: {
      get() {
        return this.params.type;
      },
      set(newValue) {
        this.params.type = newValue;
        this.$emit("change");
      }
    },
    simpleValueType: {
      get() {
        return this.params.value_type;
      },
      set(newValue) {
        this.params.value_type = newValue;
        this.$emit("change");
      }
    }
  }
};
</script>

<style scoped>
.left-padding {
  padding-left: 20px;
}
</style>
